import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";

const DateField = ({
	registeredName,
	label,
	isRequired,
	requiredText,
	placeholder,
}: {
	registeredName: string;
	label: string;
	isRequired?: boolean;
	requiredText: string;
	placeholder: string;
}) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<div className="mb-3">
			<label
				className="ml-2 block text-sm uppercase"
				htmlFor={`input-${registeredName}`}
			>
				{label}
				{isRequired && "*"}
			</label>
			{errors && (
				<p className="ml-2 text-xs text-red-500">
					<ErrorMessage errors={errors} name={registeredName} />
				</p>
			)}
			<input
				type="date"
				id={`input-${registeredName}`}
				max={new Date().toISOString().split("T")[0]}
				placeholder={placeholder}
				{...register(registeredName)}
				className="w-full border border-black px-2 py-3 placeholder:uppercase"
				required={isRequired}
			/>
		</div>
	);
};
export default DateField;
